module.exports = __webpack_public_path__ + "static/media/2.3e72cf50.png";